import { DurationFormatter } from "@/v2/components/formatters/DurationFromatter";

export function TimeToFirstResponseFormatter({
  value,
  shorthand = false,
}: {
  value: number;
  shorthand?: boolean;
}) {
  return <DurationFormatter value={value / 1000} shorthand={shorthand} />;
}